import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {RouteModel} from "../../../routes/models/route.model";
import {LeanPlanningService} from "../../../lean-planning/services/lean-planning-service.service";
import {AbsenceReasonSettings} from "../../../site-preferences/models/absence-reason-settings.model";
import {ScheduleType} from "../../../schedule/types/schedule.type";

export class AgentShiftPanel implements IController {

  route?: RouteModel;
  agent: any;
  shift: any;
  template?: any;
  date: any;
  isEdit: boolean;
  canSelectScheduleType: boolean;
  branchServiceAreasIds: string[];
  absenceReasons: AbsenceReasonSettings[];
  useShiftTypeToColor?: boolean;
  onEdit: Function;
  onAddNote: Function;
  onUpdate: Function;
  onAddBreak: Function;
  onEditBreak: Function;
  onRemoveNote: Function;
  onRemoveBreak: Function;
  onCreate: Function;
  onClose: Function;

  public shiftColor: any;
  public recurringType: any;

  // For edit mode
  public shiftCopy: any;
  public updateSpecificDay: boolean;
  public serviceAreasPriorities: any;
  public serviceAreasIds: any;
  public routeActionsMap: any;
  public priorities: any;
  public depotsRef: any;
  public depotsMap: any;
  public scheduleType: typeof ScheduleType = ScheduleType;

  /* @ngInject */
  constructor(private commonsDialogService: CommonsDialogService, private commonsConstants, private agentRequests, private commonsService: CommonsService,
              private resourcesConstants, private leanPlanningConstants, private leanPlanningService: LeanPlanningService, private $depots) {
    this.serviceAreasPriorities = this.resourcesConstants.serviceAreasPriorities;
    this.priorities = _.mapKeys(this.resourcesConstants.serviceAreasPriorities, (priority) => {
      return priority.value;
    });
  }

  $onInit() {
    this.depotsRef = this.$depots();

    if (!!this.route) {
      this.routeActionsMap = this.leanPlanningService.getRoutesActionsMap([this.route]);
    }
    this.shiftCopy = undefined;
    this.updateSpecificDay = undefined;

    if (this.shift) {
      const colorPallet = this.commonsConstants.colorPalletTwo;
      this.shiftColor = this.agent?.displayColor || this.commonsService.getColorById(_.get(this.agent, 'id'), colorPallet);
      // const rruleTypes = this.commonsConstants.rruleTypes;
      // const rrule = require('rrule');
      // const ruleOptions = rrule.RRule.fromString(_.get(this.shift, 'agentSchedule.schedule.rrule') || '').origOptions;
      // this.recurringType = _.find(rruleTypes, (t) => {
      //   return t.freq === ruleOptions.freq;
      // });
      // this.updateSpecificDay = !!this.recurringType ? false : undefined;
    }

    if (this.isEdit) {
      this.shiftCopy = angular.copy(this.shift);
    }

    this._getShiftDepotLocations(this.shift);
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.shift && !changes.shift.isFirstChange()) {
      this.$onInit();
    }
    if (changes.isEdit && !changes.isEdit.isFirstChange()) {
      this.shiftCopy = this.isEdit ? angular.copy(this.shift) : undefined;
    }
    if (changes.agent) {
      if (this.agent) {
        this.agentRequests.getAgentPreferences(this.agent.id)
          .then((preferences) => {
            this.serviceAreasIds = _.get(preferences, 'priorityServiceAreas', (this.branchServiceAreasIds || []));
          })
      } else {
        this.serviceAreasIds = [];
      }
    }
    if (changes.template) {
      this.recurringType = this.template?.schedule?.freq ? _.find(this.commonsConstants.recurringTypes, (t) => {
        return t === this.template.schedule.freq;
      }) : undefined

      this.updateSpecificDay = !!this.recurringType ? false : undefined;
    }
  }

  onToggleBlockRoute(route) {
    this.leanPlanningService.editBlockedState(route.id, !route.isBlockedByUser)
      .then((updatedRoute: RouteModel) => {
        this.route = updatedRoute;
      })
  }

  getSegmentTime(segment) {
    const segmentStartTime = this.shift.agentSchedule.schedule.startTime + segment.offsetInMillis;
    const segmentEndTime = segmentStartTime + segment.durationInMillis;

    return {notBefore: segmentStartTime, notAfter: segmentEndTime}
  }

  private _getShiftDepotLocations(shift) {
    const depotIds = [];

    if (_.get(shift, 'agentSchedule.locationSettings.departurePointType') === 'DEPOT' && _.get(shift, 'agentSchedule.locationSettings.departureId')) {
      depotIds.push(shift.agentSchedule.locationSettings.departureId);
    }

    if (_.get(shift, 'agentSchedule.locationSettings.destinationPointType') === 'DEPOT' && _.get(shift, 'agentSchedule.locationSettings.destinationId')) {
      depotIds.push(shift.agentSchedule.locationSettings.destinationId);
    }

    if (depotIds.length) {
      this._setShiftDepots(_.uniq(depotIds));
    }
  }


  private _setShiftDepots(depotIds) {
    this.depotsRef.$asyncValues(depotIds)
      .then((depots) => {
        this.depotsMap = _.keyBy(depots, 'id');
      })
      .catch((err) => {
      })
  }


}

angular
  .module('bringoz.admin.agents')
  .component('agentShiftPanel', {
    bindings: {
      route: '<?',
      agent: '<',
      shift: '<',
      template: '<?',
      date: '<',
      isEdit: '<?',
      canSelectScheduleType: '<?',
      branchServiceAreasIds: '<?',
      absenceReasons: '<?',
      useShiftTypeToColor: '<?',
      onEdit: '&',
      onAddNote: '&',
      onAddBreak: '&',
      onEditBreak: '&',
      onRemoveNote: "&",
      onRemoveBreak: '&',
      onUpdate: '&',
      onCreate: '&',
      onClose: '&'
    },
    template: require('./agent-shift-panel.html').default,
    controller: AgentShiftPanel
  });
